import Block from './block';
import ArticleTextProps from './props';
import { BlockPropsBase, BlockType } from '../..';

let getProps: typeof import('./getProps').default;
let description: typeof import('./description').default;

if (process.env.BROWSER != 'true') {
	getProps = require('./getProps').default;
}
if (process.env.BROWSER != 'true' || process.env.TARGET == 'admin') {
	description = require('./description').default;
}

const ArticleText: BlockType = {
	component: Block,
	getChildren(props: ArticleTextProps): BlockPropsBase[] {
		return [];
	},
	description,
	section: 'Article',
	info: {
		requiresParent: [],
		requiresAncestor: [ 'article/root' ],
		permittedChildren: [], 
		forbiddenAncestor: [],
		forbiddenDescendant: []
	},
	getProps,
	cacheRequiresRecord: () => false
};
export default ArticleText;

